import { ElementDetails } from "@/lib/types";
import { SlackSearchProps } from "./types";

export const details = {
  name: "SlackSearch",
  description: "A saved Slack search — messages matching a query you define",
  tags: ["Communication"],
  category: "Slack",
  grid: { default: [3, 4], large: [4, 5] },
  gridNames: { default: "Medium", large: "Large" },
  integrationsUsed: ["slack"],
  defaultProps: {},
} as ElementDetails<SlackSearchProps>;
